import { usePaginatedQuery } from '@playbookux/playbook-web-core';
import { COMPANY_UPLOAD_STORAGE_TRANSCRIBE_ERROR } from './graphql';

function useUploadsFailed() {
  return usePaginatedQuery(
    COMPANY_UPLOAD_STORAGE_TRANSCRIBE_ERROR,
    {
      fetchPolicy: 'network-only',
    },
    { dataField: 'uploadsFailed' },
  );
}

export default useUploadsFailed;
